import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { constantField, Form, textBox } from "trader.ts/ui.forms";
import { teacher_link_id } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { arrayField } from "../../client/arrayfield";
import { renderSaveButton } from "../../client/savebutton";
import { mandatoryValidation, urlValidation } from "../../lib/validate";
import * as routes from "../../routes";

export function render(opts: {
  allTeacherLinks: {
    id: teacher_link_id;
    description: string;
    url: string;
  }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("teacher_links", [], () =>
      arrayField<{
        id: teacher_link_id | null;
        description: string;
        url: string;
      }>({
        initialVal: opts.allTeacherLinks,
        makeNew: () => ({
          id: null,
          description: "",
          url: "",
        }),
        makeSubForm: async function (tl) {
          return new Form({})
            .addField("id", [], () => constantField(tl.id))
            .addField("description", [], () =>
              textBox({
                initialVal: tl.description,
                label: "Beschrijving",
                validations: [mandatoryValidation],
              }),
            )
            .addField("url", [], () =>
              textBox({
                initialVal: tl.url,
                label: "Link",
                validations: [mandatoryValidation, urlValidation],
              }),
            )
            .build({
              render: (fields) => (
                <div className={style.equal_columns}>
                  {fields.description()}
                  {fields.url()}
                </div>
              ),
            });
        },
      }),
    )
    .build();
  return (
    <div>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) => {
            return rpc(routes.saveTeacherLinksSpec, undefined, values);
          },
          reload: true,
        })}
      </div>
    </div>
  );
}
